module.exports = __webpack_public_path__ + "static/img/j1.edce9a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/j1.gif
// module id = uG5q
// module chunks = 1